module.exports = __webpack_public_path__ + "static/media/apple-logo.7b0f902a.svg";